import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import './index.less';
import './themes/default.less';

export default class Button extends MainComponent {
    static propTypes = {
        type: PropTypes.oneOf(['primary', 'secondary', 'transparent', 'dark', 'green', 'red', 'stroke', 'icon', 'dots', 'warning']),
        size: PropTypes.oneOf(['big', 'small', "mini", ""]),
        className: PropTypes.string,
        label: PropTypes.string,
        tooltip: PropTypes.string,
        icon: PropTypes.element,
        active: PropTypes.bool,
        disabled: PropTypes.bool,
        onClick: PropTypes.func
    };
    static defaultProps = {
        type: "primary",
        size: "big",
        className: "",
        label: "",
        tooltip: "",
        icon: null,
        active: false,
        disabled: false,
        onClick: null
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
        };

        this.mainStyle = ["button", "flex", "centerAll"];
    }

    render() {
        const { className, type, size, label, tooltip, icon, active, disabled, onClick } = this.props;
        const text = label ? this.tr(label) : "";
        const activeState = disabled ? "disabled" : "hand";
        const textStyle = size === "big" ? "button1" : "button2";
        const cl = [...this.mainStyle, activeState];
        const props = {};

        if (tooltip)
            props["data-tooltip"] = this.tr(tooltip);

        if (!disabled)
            cl.push(type);

        if (className)
            cl.push(className);

        if (type === "icon")
            cl.push("rad2");
        else
            cl.push(`${size} text ${textStyle} gap8 rad8`);

        if (!label)
            cl.push("lableless");
        if (active)
            cl.push("active");

        return (
            <div className={cl.join(" ")} onClick={onClick} {...props}>
                {type === "dots" ?
                    <div className="dotsCont rad4 flex centerAll">
                        {!!icon && icon}
                    </div> :
                    <>
                        {!!icon && icon}
                        {!!text && text}
                    </>}

            </div>
        );
    }
}
